import { render, staticRenderFns } from "./gameRulesScore.vue?vue&type=template&id=26046eda&scoped=true&"
import script from "./gameRulesScore.vue?vue&type=script&lang=js&"
export * from "./gameRulesScore.vue?vue&type=script&lang=js&"
import style0 from "./gameRulesScore.vue?vue&type=style&index=0&id=26046eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26046eda",
  null
  
)

export default component.exports